// Pages a customer reaches from an emailed onboarding link. The customer has no staff
// account, and these links are often opened on a device where a member of staff has
// signed in before - so these pages must never read, refresh, expire or send the staff
// session. An expired staff token left in the browser used to make every request from
// these pages fail with 401 and send the customer to the staff login page.
//
// Deliberately an explicit list, not "every route without PrivateRoute": several staff
// pages are also unwrapped and do rely on the staff session.
const CUSTOMER_ONBOARDING_ROUTE = new RegExp([
    '^/individual_onboarding_web_',
    '^/webform/',
    '^/webform_',
    '^/welcome_screen$',
    '^/corporate_welcome_screen$',
    '^/corporate_webform_',
    '^/corporate_add_',
    '^/webform_add_',
    '^/verification/face-kyc',
    '^/secure-document-upload',
    '^/kyp-checklist',
    '^/client-review',
    '^/document-checklist',
    '^/supply-chain',
    '^/refinery-onboarding',
    '^/verify-asset',
    '^/shipment',
    '^/digilocker/',
].join('|'), 'i');

export const isCustomerOnboardingRoute = (pathname) => {
    const path = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
    return CUSTOMER_ONBOARDING_ROUTE.test(String(path || ''));
};
